import React from 'react'
import Icons from '../../assets/icons'
import { Check } from 'lucide-react'

const ReloginAlert = () => {
  return (
    <div className='modal'>
        <div className='backdrop'></div>
        <div id='' className='user-online user-relogged-in'>
            <div className='uo-left ml-4 my-2 mr-3 rounded-full bg-[#03B6751A]'>
              {/* <Icons.WifiEnabledIcon /> */}
              <div className='p-[3px] rounded-full shrink-0 border-[3px] border-[#03B675]'>
                <Check color='#03B675' size={15} strokeWidth={2.75} />
              </div>
            </div>
            <div className='uo-right'>
            <h2>Welcome Back!</h2>
            <p>You have been successfully logged in again</p>
            </div>
        </div>
    </div>
  )
}

export default ReloginAlert